module.exports = __webpack_public_path__ + "img/non-manufacturing-sp.55b568fb.jpg";